import { render, staticRenderFns } from "./TokenShiftReport.vue?vue&type=template&id=c36a92e4&scoped=true&"
import script from "./TokenShiftReport.vue?vue&type=script&lang=js&"
export * from "./TokenShiftReport.vue?vue&type=script&lang=js&"
import style0 from "./TokenShiftReport.vue?vue&type=style&index=0&id=c36a92e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36a92e4",
  null
  
)

export default component.exports